import { styled } from 'styled-components';
import { Button } from '@/components/ui/Button';
import {useEffect, useRef} from "react";

const DialogOverlay = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const DialogContent = styled.div`
  position: absolute;
  right: -14px;
  top: -12px;
  height: 52px;
  background: rgb(219, 51, 36);
  padding: 10px 10px 10px 28px;

  display: flex;
  align-items: center;
  gap: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 5px;
  justify-content: flex-end;
`;

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  step: number;
}

export const DeleteConfirmDialog = ({ isOpen, setIsOpen, onConfirm, onCancel, step }: DeleteConfirmDialogProps) => {
  const menuRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if(isOpen) {
    return (
        <DialogOverlay onClick={onCancel} ref={menuRef}>
          <DialogContent onClick={e => e.stopPropagation()}>
            <h3 style={{color: '#fff', fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap'}}>
              Удалить шаг {step}?</h3>
            <ButtonGroup>
              <Button variant="delete" padding="3px 7px" onClick={onConfirm}>Да</Button>
              <Button variant="delete" padding="3px 7px" onClick={onCancel}>Нет</Button>
            </ButtonGroup>
          </DialogContent>
        </DialogOverlay>
    );
  }
};
